import Vue from 'vue'
let vue = new Vue()
let baseUrl = vue.$cdn

export default{
  kjdw: {
    title: 'Space Localization',
    dec: 'Calculate camera locations and obtain corresponding 3D point clouds to acquire information of the real-life environment.',
    points: [
      {
        posi: {
          top: '33%',
          left: '27%'
        }
      },
      {
        posi: {
          top: '20%',
          left: '50%'
        }
      },
      {
        posi: {
          top: '27%',
          left: '57%'
        }
      },
      {
        posi: {
          top: '38%',
          left: '47%'
        }
      },
      {
        posi: {
          top: '60%',
          left: '50%'
        }
      },
      {
        posi: {
          top: '63%',
          left: '63%'
        }
      },
      {
        posi: {
          top: '74%',
          left: '82%'
        }
      }
    ],
    ability: {
      name: 'The Innovative technology of AI Digitization',
      sub: 'The new algorithm has significantly enhanced the matches of feature points, thus reducing the localization loss to the lowest level. Further, bundle adjustment based on self-adaptive segmentation divides long sequences into several sequences and optimizes it in the back end, thus improving the optimization efficiency.',
      app: [
        {
          icon: {
            backgroundImage: `url(${baseUrl}images/img_core_app011.png)`
          },
          sub: 'AI Space Reconstruction Algorithm'
        },
        {
          icon: {
            backgroundImage: `url(${baseUrl}images/img_core_app022.png)`
          },
          sub: 'AI Camera Position Calculation'
        },
        {
          icon: {
            backgroundImage: `url(${baseUrl}images/img_core_app033.png)`
          },
          sub: 'AI Space Geometry Calibration'
        }
      ]
    }
  },
  kjjm: {
    title: 'Space Reconstruction',
    dec: 'Autonomous and precise 3D digitization technology that recovers floorplan and 3D structure of spacewithout manual intervention.',
    logon: '自动化高精度三维数字重建技术<br/>在获取稀疏点云和相机位姿后，计算空间的平面布局并恢复三维结构，生成3D场景。',
    chars: [
      {
        icon: {
          backgroundImage: `url(${baseUrl}images/img_core_model01.png)`

        },
        title: '',
        sub:
          'Enter the sparse point cloud and camera location data to calculate free space and core free space.'
      },
      {
        icon: {
          backgroundImage: `url(${baseUrl}images/img_core_model02.png)`
        },
        title: '',
        sub: 'Resolve the shortest path <br/>problem twice to restore thin structure.'
      },
      {
        icon: {
          backgroundImage: `url(${baseUrl}images/img_core_model03.png)`
        },
        title: '',
        sub: 'Generate a mesh model mapped with <br/>texture based on the calculated floorplan.'
      }
    ]
  },
  kjzs: {
    title: 'Space Display',
    sub: 'The calculated outcome will be displayed as Interactive 3D spaces through WebGL. Images, texts, audio, hyperlinks and other forms of media could be added to the space, and the distance measurement data could also be displayed. Alternatively, it could generate automatic tour guidance and convey enriched information in digital 3D space. ',
    sdkz: {
      name: 'Visiting museum online in 3D – 4DMuseum',
      sub: '4DMuseum is the first online art space in China integrating text and pictures, video and audio, and 3D models of artifacts and venues. It restores the on-site experience of each exhibitions, bringing the authentic charm of art to the audience. To stay tuned for the latest news and trends of art, open the 4DMuseum mini program. Without leaving home, you can visit art exhibitions and enjoy comfortable 720-degree viewing of art works. It\'s a never-ending gallery that takes you on a digital journey into art.'
    },
    zfb: {
      name: '3D real-life house visiting - Zhifangbao',
      sub: 'The Zhifangbao Platform is an integrated product of software and hardware based on 4DKanKan that meets the needs of real estate and interior design industries. Consisting of customized 3D cameras, mobile editing software and 3D platform for house display and trading, it creates a brand-new digital 3D real estate transaction experience and is applicable to various business scenarios such as renting, real estate purchase and interior design.'
    }
  },
  jianrong: {
    name: 'Compatible for multiple platforms and terminals',
    sub: 'Offers a 720° immersive roaming experience on mobile phone, tablet, PC, VR device without plug-ins.',
    terminal: [
      {
        txt: 'VR',
        img: baseUrl + 'images/img_core_platform_vr.png'
      },
      {
        txt: 'PC',
        img: baseUrl + 'images/img_core_platform_pc.png'
      },
      {
        txt: 'Mobile',
        img: baseUrl + 'images/img_core_platform_phone.png'
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/store/language/en/coreTech.js